import { Link, useRouteError } from 'react-router-dom';

const ErrorPage = () => {
  const error = useRouteError();
  const errorText =
    (error as { statusText?: string; message?: string })?.statusText ||
    (error as { message?: string })?.message ||
    'Unknown error';

  console.log('well hello :) — if you are looking for an error, the log was:', errorText);

  return (
    <main className="flex min-h-[100svh] flex-col items-center justify-center px-6 text-center">
      <span className="label mb-6">404</span>
      <h1 className="h1 max-w-[16ch]">This page doesn't exist.</h1>
      <p className="lead mt-5 max-w-[40ch]">The link may be broken, or the page may have moved.</p>
      <Link to="/" className="btn btn--lg mt-10">
        Back home <span className="arr">↗</span>
      </Link>
    </main>
  );
};

export default ErrorPage;
